export const SIGH_IN_PATH = '/';
export const HOME_PATH = '/home';
export const SIGH_OUT_PATH = '/sign-out';
export const CANDIDATES_PATH = '/candidates';
export const QBO_REDIRECT_PATH = '/qbo-redirect';
export const NOT_AUTHORIZED_PATH = '/not-authorized';
export const INTERNAL_ERROR_PATH = '/internal-error';
